import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { FieldPropsWithType } from "@/app/servers/types";

export const RetryField = ({ form, canUpdate, type }: FieldPropsWithType) => (
  <FormField
    control={form.control}
    name={`${type}.retry`}
    render={({ field }) => (
      <FormItem>
        <FormLabel>Retry</FormLabel>
        <FormControl>
          <Input
            {...field}
            disabled={!canUpdate}
            placeholder="3"
            type="number"
            // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
            value={field.value as number | undefined}
          />
        </FormControl>
        <FormDescription>
          Number of retries to attempt (including the first try)
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
);
